import React from 'react'
import { InputWrapper, Label, LoginPasswordField } from './Input.styled'

export const LoginPassword = ({ password, setState, field, labelText }) => {



    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target
        if (value.length > 1) {
            return
        }
        setState(prev => {
            const copy = structuredClone(prev)
            copy[field][name] = value
            return copy
        }
        )
        if (e.target.nextElementSibling && value.length > 0) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //  @ts-ignore
            e.target.nextElementSibling.focus()
        }

    }

    const focusPrevious = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Backspace' && !e.currentTarget.value) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //  @ts-ignore
            e.currentTarget.previousElementSibling?.focus()
        }
    }

    return (
        <InputWrapper
            nomarg={true}
        >
            <Label labelText={labelText} />
            <LoginPasswordField  >
                <input type='number' onKeyDown={focusPrevious} onChange={handleChange} name='0' value={password[0] || ''} />
                <input type='number' onKeyDown={focusPrevious} onChange={handleChange} name='1' value={password[1] || ''} />
                <input type='number' onKeyDown={focusPrevious} onChange={handleChange} name='2' value={password[2] || ''} />
                <input type='number' onKeyDown={focusPrevious} onChange={handleChange} name='3' value={password[3] || ''} />
                <input type='number' onKeyDown={focusPrevious} onChange={handleChange} name='4' value={password[4] || ''} />
                <input type='number' onKeyDown={focusPrevious} onChange={handleChange} name='5' value={password[5] || ''} />
            </LoginPasswordField>
        </InputWrapper>
    )
}